import DeleteIcon from "@mui/icons-material/Delete";
import DoDisturbOffIcon from '@mui/icons-material/DoDisturbOff';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SaveIcon from "@mui/icons-material/Save";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ConfirmAction from "../../components/Common/ConfirmAction";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { errorNotify, successNotify } from "../../util/functions";
import { updateListeEtabsSouscrit } from "../../store/focusEcoleSlice";


export default function MenuApp(props: any) {
  //props
  const { item, updateFilteredListe } = props;
  //redux
  const dispatch = useDispatch();

  //hooks
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [loading, setLoading] = useState(false);
  const [openActiveDesactive, setOpenActiveDesactive] = useState(false);


  //Ouvrir le menu
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  //Fermer le menu
  const handleClose = () => {
    setAnchorEl(null);
  };



  /////////////////////////////////////////////////// Active ou Desactive /////////////////////////////////////////////////////////
  //Ouvrir la boite de confirmation ActiveDesactive
  const handleActiveDesactiveDialogOpen = () => {
    setOpenActiveDesactive(true);
  };

  //Fermer la boite de confirmation ActiveDesactive
  const handleActiveDesactiveDialogClose = () => {
    setOpenActiveDesactive(false);
  };

  //Activer ou désactiver l'autorisation à souscrire
  const handleSave = async (e: any) => {
    e.preventDefault();
    try {
      setLoading(true);
      //Constitution du payload
      const apiPayload = {
        ...item,
        souscrit: item?.souscrit === 1 ? 0 : 1
      };
      //Envoie de la requete
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/activeoudesactiveautorisationasouscrire",
        apiPayload
      );
      if (res.status === 1) {
        dispatch(updateListeEtabsSouscrit(apiPayload));
        updateFilteredListe(apiPayload);
        setLoading(false);
        handleActiveDesactiveDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:108 ~ handleSave ~ error:", error)
      setLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };


  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Options">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            handleActiveDesactiveDialogOpen();
          }}
        >
          <ListItemIcon>
            {item.souscrit === 1
              ? <DoDisturbOffIcon fontSize="small" color="error" />
              : <DoDisturbOnIcon fontSize="small" />

            }
          </ListItemIcon>
          {item.souscrit === 1
            ? "Bloquer"
            : "Autoriser"
          }
        </MenuItem>
      </Menu>


      {/* Activer ou désactiver l'établissement */}
      <ConfirmAction
        title={`${item.souscrit === 1 ? "Bloquer" : "Autoriser"} cet établissement ?`}
        dialogContent={`Voulez vous réellement ${item.souscrit === 1 ? "empêcher" : "autoriser"} 
        cet établissement à effectuer des souscriptions et créer des comptes parentaux ?`}
        actionLabel="Oui"
        open={openActiveDesactive}
        handleClose={handleActiveDesactiveDialogClose}
        actionFunction={handleSave}
        addLoading={loading}
        iconeSauveButton={<SaveIcon />}
        cancelLabel="Non"
      />

    </React.Fragment>
  );
}
